var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"settings card-section"},[(_vm.isTablet)?_c('SettingsSelect'):_vm._e(),_c(_vm.tabComponents[_vm.routeQuery],{tag:"component",staticClass:"settings__content mt-10 mt-md-7 mt-lg-0"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }